import type {
  FilterProductType,
  Paginated,
  Sortable,
} from "@ac-expo/api-types";

const productsQueryKeys = {
  all: "products" as const,

  details: () => [productsQueryKeys.all, "details"] as const,
  detail: (id: string) => [...productsQueryKeys.details(), id],

  lists: () => [productsQueryKeys.all, "lists"] as const,
  list: (structureId: string) => [...productsQueryKeys.lists(), structureId],
  filteredList: (
    structureId: string,
    params?: Sortable<Paginated<FilterProductType>>
  ) => [...productsQueryKeys.list(structureId), params ?? {}] as const,

  listsFromOrganiser: (
    structureId: string,
    params?: Sortable<Paginated<FilterProductType>>
  ) =>
    [
      ...productsQueryKeys.filteredList(structureId, params),
      "from-organiser",
    ] as const,
  listFromOrganiser: (
    structureId: string,
    eventId: string,
    params?: Sortable<Paginated<FilterProductType>>
  ) =>
    [
      ...productsQueryKeys.listsFromOrganiser(structureId, params),
      eventId,
    ] as const,

  eventLists: (
    structureId: string,
    params?: Sortable<Paginated<FilterProductType>>
  ) =>
    [...productsQueryKeys.filteredList(structureId, params), "events"] as const,
  eventList: (
    structureId: string,
    eventId: string,
    params?: Sortable<Paginated<FilterProductType>>
  ) => [...productsQueryKeys.eventLists(structureId, params), eventId],
};

export default productsQueryKeys;
